import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { initialize } from "launchdarkly-react-client-sdk";

const DevOpsLDContext = createContext(null);

export function DevOpsLDProvider({ children }) {
  const clientRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const clientSideId = process.env.REACT_APP_LAUNCHDARKLY_DEVOPS_KEY;
    if (!clientSideId) {
      setReady(true);
      return;
    }

    const user = {
      kind: "user",
      key: process.env.REACT_APP_LAUNCHDARKLY_USER ?? "",
    };

    const client = initialize(clientSideId, user);
    clientRef.current = client;

    const onFlagChange = () => setTick((t) => t + 1);
    client.on("change", onFlagChange);

    client.on("ready", () => setReady(true));
    client.on("failed", () => setReady(true));

    return () => {
      client.off("change", onFlagChange);
      client.close();
    };
  }, []);

  if (!ready) return null;

  return (
    <DevOpsLDContext.Provider value={{ client: clientRef.current, tick }}>
      {children}
    </DevOpsLDContext.Provider>
  );
}

export function useDevOpsLDClient() {
  const ctx = useContext(DevOpsLDContext);
  return ctx?.client ?? null;
}
